import React from "react";
import { Container } from "reactstrap";
import { Link } from "react-router-dom";
// import { useNavigate } from "react-router-dom";

export function LandingPoposedToTheSubCommitteeComponent() {
    // const navigate = useNavigate();


    return (
        <Container>
            <div className="d-flex flex-wrap justify-content-center align-items-center box-reports-container">
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports">
                    <Link
                        to="/borrowing/proposal/ProposedToTheSubCommitteeForTrainForm/"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >
                        กรอกแบบเสนอคณะอนุกรรมการพิจารณาให้กู้ยืม<br />กองทุนพัฒนาฝีมือแรงงาน<br />(สำหรับผู้ดำเนินการฝึกและผู้ประกอบกิจการ)
                        {/* <p className="px-3">/p> */}
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports">
                    <Link
                        to="/borrowing/proposal/ProposedToTheSubCommitteeForEstimateForm/"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >
                        กรอกแบบเสนอคณะอนุกรรมการพิจารณาให้กู้ยืม<br />กองทุนพัฒนาฝีมือแรงงาน<br />(สำหรับผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงาน<br />และผู้ประกอบกิจการ)
                        {/* <p className="px-3">/p> */}
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports">
                    <Link
                        to="/borrowing/proposal/TestInfomationForBorrowing"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >
                        ข้อมูลการขอกู้ยืมกองทุนพัฒนาฝีมือแรงงาน<br />(สำหรับผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงาน<br />และผู้ประกอบกิจการ)
                        {/* <p className="px-3">/p> */}
                    </Link>
                </div>


                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports">
                    <Link
                        to="/borrowing/proposal/ProposedToTheSubCommitteeForTrainView/"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >
                        ข้อมูลแบบเสนอคณะอนุกรรมการพิจารณาให้กู้ยืม<br />กองทุนพัฒนาฝีมือแรงงาน<br />(สำหรับผู้ดำเนินการฝึกและผู้ประกอบกิจการ)
                        {/* <p className="px-3">/p> */}
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports">
                    <Link
                        to="/borrowing/proposal/ProposedToTheSubCommitteeForEstimateView/"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >
                        ข้อมูลแบบเสนอคณะอนุกรรมการพิจารณาให้กู้ยืม<br />กองทุนพัฒนาฝีมือแรงงาน<br />(สำหรับผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงาน<br />และผู้ประกอบกิจการ)
                        {/* <p className="px-3">/p> */}
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports">
                    <Link
                        to="/borrowing/proposal/TrainInfomationForBorrowing"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >
                        ข้อมูลการขอกู้ยืมกองทุนพัฒนาฝีมือแรงงาน<br />(สำหรับผู้ดำเนินการฝึกและผู้ประกอบกิจการ)
                        {/* <p className="px-3">/p> */}
                    </Link>
                </div>



                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports">
                    <Link
                        to="/borrowing/proposal/ProposedToTheSubCommitteeForTrainApproveView"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >
                        มติคณะอนุกรรมการพิจารณาให้กู้ยืม<br />กองทุนพัฒนาฝีมือแรงงาน<br />(สำหรับผู้ดำเนินการฝึกและผู้ประกอบกิจการ)
                        {/* <p className="px-3">/p> */}
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports">
                    <Link
                        to="/borrowing/proposal/ProposedToTheSubCommitteeForEstimateApproveView/"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >
                        มติคณะอนุกรรมการพิจารณาให้กู้ยืม<br />กองทุนพัฒนาฝีมือแรงงาน<br />(สำหรับผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงาน<br />และผู้ประกอบกิจการ)
                        {/* <p className="px-3">/p> */}
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports">
                    <Link
                        to="/borrowing/proposal/DetailInfomationForBorrowing"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >
                        ข้อมูลประกอบการประชุมคณะอนุกรรมการพิจารณา<br />การให้เงินกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน
                        {/* <p className="px-3">/p> */}
                    </Link>
                </div>

                



                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports">
                    <Link
                        to="/borrowing/proposal/ProposedToTheSubCommitteeForTrainEditView/"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >
                        มติแบบเสนอคณะอนุกรรมการพิจารณาให้กู้ยืม<br />กองทุนพัฒนาฝีมือแรงงาน(กรณีขอเปลี่ยนแปลง)<br />(สำหรับผู้ดำเนินการฝึกและผู้ประกอบกิจการ)
                        {/* <p className="px-3">/p> */}
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports">
                    <Link
                        to="/borrowing/proposal/ProposedToTheSubCommitteeForEstimateEditView/"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >
                        มติแบบเสนอคณะอนุกรรมการพิจารณาให้กู้ยืม<br />กองทุนพัฒนาฝีมือแรงงาน(กรณีขอเปลี่ยนแปลง)<br />(สำหรับผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงาน<br />และผู้ประกอบกิจการ)
                        {/* <p className="px-3">/p> */}
                    </Link>
                </div>



                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports">
                    <Link
                        to="/borrowing/proposal/DuplicateRecoveryInfomationForBorrowing"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >
                        ข้อมูลการขอกู้ซ้ำของสถานประกอบการ
                        {/* <p className="px-3">/p> */}
                    </Link>
                </div>


            </div>
            <div class="boxes-tn">
                <div></div> <div></div>
                <div></div> <div></div>
                <div></div> <div></div>
                <div></div> <div></div>
                <div></div>
            </div>
        </Container>


    )

}